import(/* webpackMode: "eager" */ "/app/apps/PublicUI/app/(embeds)/embed/[educator_param]/[course_param]/not-found.tsx");
